import MyAssetsContainer from '../../containers/MyAssets';

function MyAssets(){

  return <MyAssetsContainer />
}

export default MyAssets